import './styles/index.scss';

import { QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from 'components/ErrorBoundary';
import { queryClient } from 'configs/client';
import { LocalStorageKey } from 'configs/constants';
import { isDev } from 'configs/env';
import React, { StrictMode, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import { MainService } from 'services';

// import { AppRoutes } from './AppRoutes';
import { ImageGallery } from './components/image-gallery';
import { routesDefined } from './routes';

const Routes = () => useRoutes(routesDefined);
const routerFuture = { v7_startTransition: true };

const App = () => {
  useEffect(() => {
    MainService.initializeClient();
  }, []);

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === LocalStorageKey.SESSION_MARKER) {
        // Another tab logged in or out — reload to sync auth state
        window.location.reload();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {(isDev && (
        <StrictMode>
          <Router future={routerFuture}>
            <Routes />
          </Router>
        </StrictMode>
      )) || (
        <ErrorBoundary>
          <Router future={routerFuture}>
            <Routes />
          </Router>
        </ErrorBoundary>
      )}
      <ImageGallery />
      <Toaster />
    </QueryClientProvider>
  );
};

export default App;
